import * as Yup from "yup";
import { emailAdressValidator } from "../../../Utils/stringUtls";

const generalErrorMessage = "Field is required";
export const validationSchemaRequiredFields = Yup.object({
  pf_applicable_pf: Yup.array()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_applicable_pf_other: Yup.string().when(["pf_applicable_pf"], {
    is: (pf_applicable_pf) => pf_applicable_pf.includes(11),
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_card_be_charged: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_type_of_credit_line: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_type_of_credit_line_company_name: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_contact_name: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_job_title: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_phone_number: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_email: Yup.string().when("pf_type_of_credit_line", {
    is: (pf_type_of_credit_line) =>
      pf_type_of_credit_line && pf_type_of_credit_line === "secure",
    then: () =>
      Yup.string()
        .required(generalErrorMessage)
        .test("", "", function (item) {
          // this.parent gives the whole parent
          return emailAdressValidator(item);
        }),
    otherwise: () => Yup.string().optional(),
  }),
  pf_credit_decisioning: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_credit_decisioning_fico_vendor: Yup.string().when(
    "pf_credit_decisioning",
    {
      is: (pf_credit_decisioning) =>
        pf_credit_decisioning && pf_credit_decisioning === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_fico_vendor_other: Yup.string().when(
    ["pf_credit_decisioning", "pf_credit_decisioning_fico_vendor"],
    {
      is: (pf_credit_decisioning, pf_credit_decisioning_fico_vendor) =>
        pf_credit_decisioning === "yes" &&
        pf_credit_decisioning_fico_vendor === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc: Yup.string().when("pf_credit_decisioning", {
    is: (pf_credit_decisioning) =>
      pf_credit_decisioning && pf_credit_decisioning === "no",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),

  pf_credit_decisioning_chc_company_name: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_contact_name: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_job_title: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_phone_number: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_email: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_workflow_and_decision_file: Yup.string().optional(),
  pf_manual_review: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_manual_review_company_name: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_contact_name: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_job_title: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_phone_number: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_email: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () =>
      Yup.string()
        .required(generalErrorMessage)
        .test("", "", function (item) {
          // this.parent gives the whole parent
          return emailAdressValidator(item);
        }),
    otherwise: () => Yup.string().optional(),
  }),

  pf_credit_limit: Yup.array().optional(),
  pf_credit_limit_modification: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_clm_delinquent: Yup.array().when("pf_credit_limit_modification", {
    is: (pf_credit_limit_modification) =>
      pf_credit_limit_modification === "yes",
    then: () =>
      Yup.array()
        .of(
          Yup.object({
            pf_clm_deliquency_action: Yup.string()
              .required(generalErrorMessage)
              .min(1, generalErrorMessage),
            pf_clm_days_past_dueL: Yup.string()
              .required(generalErrorMessage)
              .min(1, generalErrorMessage),
            pf_clm_days_month_opt: Yup.string()
              .required(generalErrorMessage)
              .min(1, generalErrorMessage),
          }),
        )
        .min(1, generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),

  pf_kyc_process: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_kyc_conduct: Yup.string().when(["pf_kyc_process"], {
    is: (pf_kyc_process) => pf_kyc_process === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_kyc_conduct_other_company: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_contact_name: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_title: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_phone: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_email: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pf_kyc_conduct_other_address: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pf_kyb_process: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_kyb_responsibility: Yup.string().when(["pf_kyb_process"], {
    is: (pf_kyb_process) => pf_kyb_process === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_kyb_responsibility_other_company: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_contact_name: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_title: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_phone: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_email: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pf_kyb_responsibility_other_address: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_card_order_placement: Yup.array().optional(),
  pf_card_order_placement_channel: Yup.array().optional(),
  pf_card_order_placement_channel_other: Yup.string().when(
    ["pf_card_order_placement_channel"],
    {
      is: (pf_card_order_placement_channel) =>
        pf_card_order_placement_channel &&
        pf_card_order_placement_channel.includes(5),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_card_activation_channel: Yup.array().optional(),
  pf_card_activation_channel_other: Yup.string().when(
    ["pf_card_activation_channel"],
    {
      is: (pf_card_activation_channel) =>
        pf_card_activation_channel && pf_card_activation_channel.includes(5),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_pin_management: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_pin_manage_default_pin: Yup.string().when(["pf_pin_management"], {
    is: (pf_pin_management) =>
      pf_pin_management && pf_pin_management === "default-pin",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_pin_manage_default_pin_other: Yup.string().when(
    ["pf_pin_management", "pf_pin_manage_default_pin"],
    {
      is: (pf_pin_management, pf_pin_manage_default_pin) =>
        pf_pin_management === "default-pin" &&
        pf_pin_manage_default_pin === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_card_statement_printing_mailing_services: Yup.string().optional(),
  pf_letter_mail_generation_services: Yup.string().optional(),
  pf_pin_mailer: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_offline_pin_support: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_consumer_payment_opt: Yup.array().optional(),
  pf_consumer_payment_opt_other: Yup.string().when(
    ["pf_consumer_payment_opt"],
    {
      is: (pf_consumer_payment_opt) =>
        pf_consumer_payment_opt && pf_consumer_payment_opt.includes(3),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  //

  pf_lockbox_services: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_lockbox_services_other_company: Yup.string().when(
    ["pf_lockbox_services"],
    {
      is: (pf_lockbox_services) =>
        pf_lockbox_services && pf_lockbox_services === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_lockbox_services_other_contact_name: Yup.string().when(
    ["pf_lockbox_services"],
    {
      is: (pf_lockbox_services) =>
        pf_lockbox_services && pf_lockbox_services === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_lockbox_services_other_title: Yup.string().when(["pf_lockbox_services"], {
    is: (pf_lockbox_services) =>
      pf_lockbox_services && pf_lockbox_services === "other",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_lockbox_services_other_phone: Yup.string().when(["pf_lockbox_services"], {
    is: (pf_lockbox_services) =>
      pf_lockbox_services && pf_lockbox_services === "other",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_lockbox_services_other_email: Yup.string().when(["pf_lockbox_services"], {
    is: (pf_lockbox_services) =>
      pf_lockbox_services && pf_lockbox_services === "other",
    then: () =>
      Yup.string()
        .required(generalErrorMessage)
        .test("", "", function (item) {
          // this.parent gives the whole parent
          return emailAdressValidator(item);
        }),
    otherwise: () => Yup.string().optional(),
  }),
  pf_min_payment_threshold: Yup.string().optional(),
  pf_min_payment_additional_amount: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_payment_dist_opt_greater_min: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_payment_dist_opt_for_min: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_min_pc_pcalc_method: Yup.string().optional(),
  pf_min_pc_pprcntg_value: Yup.string().optional(),
  pf_min_pc_scalc_method: Yup.string().optional(),
  pf_min_pc_sprcntg_value: Yup.string().optional(),
  pf_payment_due_date_policy: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_payment_due_date_policy_fixed_date: Yup.string().when(
    ["pf_payment_due_date_policy"],
    {
      is: (pf_payment_due_date_policy) =>
        pf_payment_due_date_policy &&
        pf_payment_due_date_policy === "fixed-date",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test(
            "valid-day-of-month",
            "Due date must be between 1 and 31",
            (val) => {
              if (!val) return false;
              const num = parseInt(val, 10);
              return !isNaN(num) && num >= 1 && num <= 31;
            },
          ),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_payment_due_date_policy_no_of_days: Yup.string().when(
    ["pf_payment_due_date_policy"],
    {
      is: (pf_payment_due_date_policy) =>
        pf_payment_due_date_policy &&
        pf_payment_due_date_policy === "no-of-days",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_late_payment_penalty: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_late_payment_fee: Yup.string().when(["pf_late_payment_penalty"], {
    is: (pf_late_payment_penalty) =>
      pf_late_payment_penalty && pf_late_payment_penalty === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_grace_period: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_grace_period_days: Yup.string().when(["pf_grace_period"], {
    is: (pf_grace_period) => pf_grace_period && pf_grace_period === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_card_account_statement: Yup.array().optional(),
  pf_statement_generation: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_statment_generation_date: Yup.string().when(["pf_statement_generation"], {
    is: (pf_statement_generation) =>
      pf_statement_generation && pf_statement_generation === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),

  pf_credit_card_collection_detail: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_credit_card_collection_detail_provider: Yup.string().when(
    ["pf_credit_card_collection_detail"],
    {
      is: (pf_credit_card_collection_detail) =>
        pf_credit_card_collection_detail &&
        pf_credit_card_collection_detail === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_card_collection_detail_provider_other: Yup.string().when(
    [
      "pf_credit_card_collection_detail",
      "pf_credit_card_collection_detail_provider",
    ],
    {
      is: (
        pf_credit_card_collection_detail,
        pf_credit_card_collection_detail_provider,
      ) =>
        pf_credit_card_collection_detail === "yes" &&
        pf_credit_card_collection_detail_provider === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_bureau_report_required: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_credit_reporting_bureaus: Yup.array().when(
    ["pf_credit_bureau_report_required"],
    {
      is: (pf_credit_bureau_report_required) =>
        pf_credit_bureau_report_required &&
        pf_credit_bureau_report_required === "yes",
      then: () =>
        Yup.array().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.array().optional(),
    },
  ),
  pf_credit_reporting_bureaus_other: Yup.string().when(
    ["pf_credit_bureau_report_required", "pf_credit_reporting_bureaus"],
    {
      is: (pf_credit_bureau_report_required, pf_credit_reporting_bureaus) =>
        pf_credit_bureau_report_required === "yes" &&
        pf_credit_reporting_bureaus.includes(3),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_card_usage_restriction: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_cash_advance_limit: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_cardholder_notification: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  // pf_cardholder_notification_channels: Yup.string()
  //   .required(generalErrorMessage)
  //   .min(1, generalErrorMessage),
  pf_cardholder_notification_channels: Yup.mixed().when(
    "pf_cardholder_notification",
    {
      is: (val) =>
        val && val.trim() !== "" && val.toLowerCase() !== "n/a",
      then: (schema) =>
        schema.test(
          "has-value",
          generalErrorMessage,
          function (value) {
            // For "send-alert-to-cardholder", expect array with at least 1 item
            if (this.parent.pf_cardholder_notification === "send-alert-to-cardholder") {
              return Array.isArray(value) && value.length > 0;
            }
            // For other options, expect non-empty string
            return typeof value === "string" && value.length > 0;
          }
        ),
      otherwise: (schema) => schema.notRequired(),
    }
  ),

  pf_customer_support_channels: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_customer_support_who_will_provide: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_customer_support_provider_other_company: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_contact_name: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_title: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_phone: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_email: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),
});
const optionalString = Yup.string().optional();
const optionalArray = Yup.array().optional();

const optionalEmail = Yup.string()
  .optional()
  .test("email", "Invalid email", (val) => {
    if (!val) return true;
    return emailAdressValidator(val);
  });

const minIfPresentArray = (message) =>
  Yup.array().test(
    "min-if-present",
    message,
    (val) => !val || val.length > 0
  );

export const validationSchema = Yup.object({

  // Basic
  pf_applicable_pf: optionalArray,
  pf_applicable_pf_other: optionalString,

  pf_card_be_charged: optionalString,
  pf_type_of_credit_line: optionalString,

  pf_type_of_credit_line_company_name: optionalString,
  pf_type_of_credit_line_contact_name: optionalString,
  pf_type_of_credit_line_job_title: optionalString,
  pf_type_of_credit_line_phone_number: optionalString,
  pf_type_of_credit_line_email: optionalEmail,

  // Credit Decisioning
  pf_credit_decisioning: optionalString,
  pf_credit_decisioning_fico_vendor: optionalString,
  pf_credit_decisioning_fico_vendor_other: optionalString,

  pf_credit_decisioning_chc: optionalString,
  pf_credit_decisioning_chc_company_name: optionalString,
  pf_credit_decisioning_chc_contact_name: optionalString,
  pf_credit_decisioning_chc_job_title: optionalString,
  pf_credit_decisioning_chc_phone_number: optionalString,
  pf_credit_decisioning_chc_email: optionalEmail,

  // Manual Review
  pf_workflow_and_decision_file: optionalString,
  pf_manual_review: optionalString,

  pf_manual_review_company_name: optionalString,
  pf_manual_review_contact_name: optionalString,
  pf_manual_review_job_title: optionalString,
  pf_manual_review_phone_number: optionalString,
  pf_manual_review_email: optionalEmail,

  // Credit Limit
  pf_credit_limit: optionalArray,
  pf_credit_limit_modification: optionalString,

  pf_clm_delinquent: Yup.array().when("pf_credit_limit_modification", {
    is: "yes",
    then: () =>
      minIfPresentArray(generalErrorMessage).of(
        Yup.object({
          pf_clm_deliquency_action: optionalString,
          pf_clm_days_past_dueL: optionalString,
          pf_clm_days_month_opt: optionalString,
        })
      ),
    otherwise: () => optionalArray,
  }),

  // KYC
  pf_kyc_process: optionalString,
  pf_kyc_conduct: optionalString,

  pf_kyc_conduct_other_company: optionalString,
  pf_kyc_conduct_other_contact_name: optionalString,
  pf_kyc_conduct_other_title: optionalString,
  pf_kyc_conduct_other_phone: optionalString,
  pf_kyc_conduct_other_email: optionalEmail,
  pf_kyc_conduct_other_address: optionalString,

  // KYB
  pf_kyb_process: optionalString,
  pf_kyb_responsibility: optionalString,

  pf_kyb_responsibility_other_company: optionalString,
  pf_kyb_responsibility_other_contact_name: optionalString,
  pf_kyb_responsibility_other_title: optionalString,
  pf_kyb_responsibility_other_phone: optionalString,
  pf_kyb_responsibility_other_email: optionalEmail,
  pf_kyb_responsibility_other_address: optionalString,

  // Card Ops
  pf_card_order_placement: optionalArray,
  pf_card_order_placement_channel: optionalArray,
  pf_card_order_placement_channel_other: optionalString,

  pf_card_activation_channel: optionalArray,
  pf_card_activation_channel_other: optionalString,

  pf_pin_management: optionalString,
  pf_pin_manage_default_pin: optionalString,
  pf_pin_manage_default_pin_other: optionalString,

  pf_credit_card_statement_printing_mailing_services: optionalString,
  pf_letter_mail_generation_services: optionalString,
  pf_pin_mailer: optionalString,
  pf_offline_pin_support: optionalString,

  pf_consumer_payment_opt: optionalArray,
  pf_consumer_payment_opt_other: optionalString,

  // Lockbox
  pf_lockbox_services: optionalString,
  pf_lockbox_services_other_company: optionalString,
  pf_lockbox_services_other_contact_name: optionalString,
  pf_lockbox_services_other_title: optionalString,
  pf_lockbox_services_other_phone: optionalString,
  pf_lockbox_services_other_email: optionalEmail,

  // Payments
  pf_min_payment_threshold: optionalString,
  pf_min_payment_additional_amount: optionalArray,
  pf_payment_dist_opt_greater_min: optionalString,
  pf_payment_dist_opt_for_min: optionalString,
  pf_payment_statement_cycle_duration: optionalString,
  
  pf_min_pc_pcalc_method: optionalString,
  pf_min_pc_pprcntg_value: optionalString,
  pf_min_pc_scalc_method: optionalString,
  pf_min_pc_sprcntg_value: optionalString,

  pf_payment_due_date_policy: optionalString,
  pf_payment_due_date_policy_fixed_date: Yup.string().when(
    ["pf_payment_due_date_policy"],
    {
      is: (pf_payment_due_date_policy) =>
        pf_payment_due_date_policy === "fixed-date",
      then: () =>
        Yup.string()
          .optional()
          .test(
            "valid-day-of-month",
            "Due date must be between 1 and 31",
            (val) => {
              if (!val || val === "") return true;
              const num = parseInt(val, 10);
              return !isNaN(num) && num >= 1 && num <= 31;
            },
          ),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_payment_due_date_policy_no_of_days: optionalString,

  pf_late_payment_penalty: optionalString,
  pf_late_payment_fee: optionalString,

  pf_grace_period: optionalString,
  pf_grace_period_days: optionalString,

  // Statements
  pf_card_account_statement: optionalArray,
  pf_statement_generation: optionalString,
  pf_statment_generation_date: optionalString,

  // Collections
  pf_credit_card_collection_detail: optionalString,
  pf_credit_card_collection_detail_provider: optionalString,
  pf_credit_card_collection_detail_provider_other: optionalString,
  pf_credit_card_collection_detail_provider_other_title: optionalString,
  pf_credit_card_collection_detail_provider_other_email: optionalEmail,
  pf_credit_card_collection_detail_provider_other_phone: optionalString,
  pf_credit_card_collection_detail_provider_other_phone_country: optionalString,
  pf_credit_card_collection_detail_provider_other_address: optionalString,

  // Bureau
  pf_credit_bureau_report_required: optionalString,

  pf_credit_reporting_bureaus: optionalArray,

  pf_credit_reporting_bureaus_other: optionalString,

  // Misc
  pf_card_usage_restriction: optionalString,
  pf_cash_advance_limit: optionalString,

  pf_cardholder_notification: optionalString,
  pf_cardholder_notification_channels: Yup.mixed().optional(),

  // Support
  pf_customer_support_channels: optionalString,
  pf_customer_support_who_will_provide: optionalString,

  pf_customer_support_provider_other_company: optionalString,
  pf_customer_support_provider_other_contact_name: optionalString,
  pf_customer_support_provider_other_title: optionalString,
  pf_customer_support_provider_other_phone: optionalString,
  pf_customer_support_provider_other_email: optionalEmail,

});